import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import api from "@/api/api.js";
import CompanyCard from "@/pages/shared/sections/CompanyCard.jsx";
import RequestTicket from "@/pages/shared/sections/RequestTicket.jsx";
import FiscalDocumentUpload from "@/pages/shared/sections/FiscalDocumentUpload.jsx";
import { useState, useEffect } from "react";

const RequestTicketDetail = () => {
  const { id, companyId } = useParams();
  const [company, setCompany] = useState(null);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCompany = async () => {
    console.log("ajax");
    try {
      const response = await api.get(`/companies/${companyId}`);
      setCompany(response.data);
      console.debug(response.data);
    } catch {
      setError("Company not founds.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(id);
    console.log(companyId);
    fetchCompany();
  }, []);

  if (loading) {
    return <p>Cargando...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }
  return (
    <>
      <Row>
        <Col xs={4}>
          <CompanyCard company={company} />
          <FiscalDocumentUpload companyId={company.id} />
        </Col>
        <Col xs={8}>
          <RequestTicket requestId={id} />
        </Col>
      </Row>
    </>
  );
};

export default RequestTicketDetail;
